var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarketMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5285 3.15106C21.8217 3.33361 22 3.65458 22 4V17.0485C22 17.4297 21.7834 17.7776 21.4414 17.9459L15.4414 20.8973C15.1631 21.0342 14.8369 21.0342 14.5586 20.8973L9 18.163L3.4414 20.8973C3.13144 21.0498 2.76475 21.0315 2.47151 20.8489C2.17827 20.6664 2 20.3454 2 20V6.95146C2 6.57034 2.21663 6.22237 2.5586 6.05415L8.5586 3.10269C8.83694 2.96577 9.16306 2.96577 9.4414 3.10269L15 5.83702L20.5586 3.10269C20.8686 2.95022 21.2352 2.96851 21.5285 3.15106ZM14 7.57399L10 5.60635V16.426L14 18.3937V7.57399ZM16 18.3937L20 16.426V5.60635L16 7.57399V18.3937ZM8 16.426V5.60635L4 7.57399V18.3937L8 16.426Z",
    fill: "#3B445A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketMap);
export default __webpack_public_path__ + "static/media/market-map.5a2d7893f6171cb6b3a44a7f5e8a9021.svg";
export { ForwardRef as ReactComponent };